var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInventory2Grey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1274_26719",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 31,
    height: 30
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 30,
    height: 30,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1274_26719)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.75 27.5C6.0625 27.5 5.47396 27.2552 4.98438 26.7656C4.49479 26.276 4.25 25.6875 4.25 25V10.9062C3.875 10.6771 3.57292 10.3802 3.34375 10.0156C3.11458 9.65104 3 9.22917 3 8.75V5C3 4.3125 3.24479 3.72396 3.73438 3.23438C4.22396 2.74479 4.8125 2.5 5.5 2.5H25.5C26.1875 2.5 26.776 2.74479 27.2656 3.23438C27.7552 3.72396 28 4.3125 28 5V8.75C28 9.22917 27.8854 9.65104 27.6562 10.0156C27.4271 10.3802 27.125 10.6771 26.75 10.9062V25C26.75 25.6875 26.5052 26.276 26.0156 26.7656C25.526 27.2552 24.9375 27.5 24.25 27.5H6.75ZM5.5 8.75H25.5V5H5.5V8.75ZM13 17.5H18C18.3542 17.5 18.651 17.3802 18.8906 17.1406C19.1302 16.901 19.25 16.6042 19.25 16.25C19.25 15.8958 19.1302 15.599 18.8906 15.3594C18.651 15.1198 18.3542 15 18 15H13C12.6458 15 12.349 15.1198 12.1094 15.3594C11.8698 15.599 11.75 15.8958 11.75 16.25C11.75 16.6042 11.8698 16.901 12.1094 17.1406C12.349 17.3802 12.6458 17.5 13 17.5Z",
    fill: "#ADBBCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInventory2Grey);
export default __webpack_public_path__ + "static/media/icon_inventory_2_grey.f54277aeca327434e21e791008b0f6e5.svg";
export { ForwardRef as ReactComponent };